module.exports = __webpack_public_path__ + "img/LebaraDisabeld.53e0bfec.svg";